module.exports = {
    "enus": require("./enus.js"),
    "zhcn": require("./zhcn.js"),
    "zhtw": require("./zhtw.js"),
    "zhhk": require("./zhhk.js"),
    "areg": require("./areg.js"),
    "frfr": require("./frfr.js"),
    "jajp": require("./jajp.js"),
    "ptpt": require("./ptpt.js"),
    "ruru": require("./ruru.js"),
    "vivn": require("./vivn.js"),
    "kokr": require("./kokr.js"),
    "eses": require("./eses.js"),
    "msmy": require("./msmy.js"),
    "idid": require("./idid.js"),
    "thth": require("./thth.js"),
    "trtr": require("./trtr.js"),
};


// WEBPACK FOOTER //
// ./js/lang/pack.js